export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8678.49d6b525.jpg";